export const MONTHLY_MEDALS = [
  ['Janeiro', '04 amigo do bem.png'],
  ['Fevereiro', '05 estrelda da solidariedade.png'],
  ['Março', '06 campeao de causas.png'],
  ['Abril', '07 faz a diferenca.png'],
  ['Maio', '08 semeador de esperanca.png'],
  ['Junho', '09 impacto no mundo.png'],
  ['Julho', '10 legado de impacto.png'],
  ['Agosto', '11 coracao solidario .png'],
  ['Setembro', '12 transformandor de realidades.png'],
  ['Outubro', '13 lenda da generosidade.png'],
  ['Novembro', '15 anjo do bem.png'],
  ['Dezembro', '16 doacao rara.png'],
].map(([month, file], index) => ({
  id: `monthly_${String(index + 1).padStart(2, '0')}` as MonthlyMedalId,
  month,
  image: `/conquistas%20doa%C3%A7%C3%B5es/${encodeURIComponent(file)}`,
}))

export type MonthlyMedalId = `monthly_${string}`
